// @flow
import { createUniversalRoute } from "../../utils/createUniversalRoute";

const routes = [
  {
    path: "/blog",
    exact: true,
    name: "RebrandBlogHome",
  },
  {
    path: "/blog/posts/:id",
    name: "RebrandBlogPost",
  },
  {
    path: "/blog/categories/:id",
    name: "RebrandBlogCategory",
  },
];

export const blogRoutes = routes.map<*>(createUniversalRoute);
